<script setup lang="ts">
  import { computed } from 'vue'
  import { useRoute, useRouter } from 'vue-router'

  const router = useRouter()
  const route = useRoute()
  const isActive = computed(() => props.to && route.path === props.to)

  const props = defineProps<{
    highlighted?: boolean
    more?: boolean
    to?: string
    href?: string
    click?: () => void
    icon?: string
    name: string
  }>()

  const onClick = function () {
    if (props.to) {
      router.push(props.to)
    } else if (props.href) {
      location.href = props.href
    } else if (props.click) {
      props.click()
    }
  }
</script>

<template>
  <a
    @click="onClick()"
    class="py-2 cursor-pointer leading-4 rounded-lg items-center text-sm gap-2 inline-flex hover:bg-white-gray select-none justify-start px-3"
    :class="{
      'bg-white-gray': isActive,
      'text-blue-60': highlighted,
    }"
    data-nav-item
  >
    <des-icon v-if="icon" :icon="icon" class="h-icon w-icon" />
    <span class="text-ellipsis overflow-hidden grow" data-nav-label>
      {{ name }}
    </span>
    <des-icon v-if="more" icon="fa-light fa-chevron-right" class="pointer-events-none h-icon w-icon" />
  </a>
</template>
